import { useContext, useMemo, useEffect, useState, useCallback } from "react";
import { LocaleContext } from "../app";

export function Tellit({ name, url }) {
  const { translate } = useContext(LocaleContext);
  const tellitParams = useMemo(() => {
    return Object.entries(translate(["tellits", name])).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [`data-param-${key}`]: value,
      }),
      {},
    );
  }, [translate, name]);

  return (
    <>
      <ScrollIndicator />
      <tellit-player data-story-url={url} {...tellitParams}></tellit-player>
    </>
  );
}

const SCROLL_INDICATOR_UNTIL = 500;

function ScrollIndicator() {
  const { translate } = useContext(LocaleContext);
  const [hidden, setHidden] = useState(window.scrollY > SCROLL_INDICATOR_UNTIL);

  const onScroll = useCallback(() => {
    setHidden(window.scrollY > SCROLL_INDICATOR_UNTIL);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [onScroll]);

  return (
    <div className="scroll-indicator" hidden={hidden}>
      <p className="scroll-indicator__text">
        {translate("general.scroll_down")}
      </p>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="currentColor"
        className="scroll-indicator__icon"
        aria-hidden="true"
      >
        <path d="M8.00024 12.696L4.00024 8.69603L4.93358 7.7627L8.00024 10.8127L11.0669 7.7627L12.0002 8.69603L8.00024 12.696ZM8.00024 8.69603L4.00024 4.69603L4.93358 3.7627L8.00024 6.8127L11.0669 3.7627L12.0002 4.69603L8.00024 8.69603Z" />
      </svg>
    </div>
  );
}
